import { useQuery } from "@tanstack/react-query";
import { PodCard } from "@/components/site/PodCard";
import { api } from "@/lib/api";

export const Related = ({ current }) => {
  const { data } = useQuery({ queryKey: ["products"], queryFn: () => api.get("/products").then((r) => r.data) });
  const others = (Array.isArray(data) ? data : []).filter((p) => p.id !== current.id);
  const picks = [...others.filter((p) => p.source === current.source), ...others.filter((p) => p.source !== current.source)].slice(0, 4);
  if (!picks.length) return null;
  return (
    <section className="border-t border-line px-5 py-20 sm:px-8 lg:px-12" data-testid="related-products">
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">Ti potrebbe piacere</p>
      <div className="mt-8 grid grid-cols-1 gap-x-5 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {picks.map((p, i) => <PodCard key={p.id} product={p} index={i} />)}
      </div>
    </section>
  );
};
